import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import ajaxWrapper from 'base/ajax.js';
import Wrapper from 'base/wrapper.js';
import { Alert, Modal } from 'library';

const EMPTY_USER = {
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  is_staff: false,
  active: true,
  is_active: true,
};

class InviteUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [], company: {}, can_manage: false, can_remove: false, loaded: false, saving: false,
      error: '', modal_error: '', success: '', form_mode: null, form_user: { ...EMPTY_USER },
      deactivation: null, deactivation_action: 'deactivate', replacement_user_id: '',
      deactivation_is_staff: null,
      reactivation: null,
      search_query: '', status_filter: 'all',
      sort_key: 'name', sort_direction: 'ascending', page_offset: 1, limit: 10,
      total_count: 0, page_count: 0, active_user_count: 0, active_admin_count: 0,
      loading_users: false,
    };

    this.refresh = this.refresh.bind(this);
    this.openCreate = this.openCreate.bind(this);
    this.openEdit = this.openEdit.bind(this);
    this.closeForm = this.closeForm.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.openDeactivation = this.openDeactivation.bind(this);
    this.openReassign = this.openReassign.bind(this);
    this.closeDeactivation = this.closeDeactivation.bind(this);
    this.confirmDeactivation = this.confirmDeactivation.bind(this);
    this.deleteFromForm = this.deleteFromForm.bind(this);
    this.openReactivation = this.openReactivation.bind(this);
    this.closeReactivation = this.closeReactivation.bind(this);
    this.confirmReactivation = this.confirmReactivation.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleLimitChange = this.handleLimitChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
  }

  componentDidMount() {
    this.refresh();
  }

  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  apiRequest(type, url, data, onSuccess, error_key = 'error') {
    var handleFailure = (xhr) => {
      var response = xhr.responseJSON || {};
      this.setState({
        saving: false,
        loaded: true,
        [error_key]: response.error || 'The request could not be completed.',
      });
    };
    var handleSuccess = (result) => {
      // Preserve the wrapper's legacy 400 response shape as a real form error.
      if (result && result.error) {
        handleFailure({ responseJSON: result });
        return;
      }
      onSuccess(result);
    };
    return ajaxWrapper(type, url, data, handleSuccess, handleFailure);
  }

  refresh() {
    this.usersRequestId = (this.usersRequestId || 0) + 1;
    var request_id = this.usersRequestId;
    this.setState({ loading_users: true });
    this.apiRequest(
      'GET',
      `/users/company-users/${this.props.company_id}/`,
      {
        page: this.state.page_offset,
        page_size: this.state.limit,
        search: this.state.search_query.trim(),
        status: this.state.status_filter,
        sort_by: this.state.sort_key,
        direction: this.state.sort_direction,
      },
      (result) => {
        // Ignore an older response if the user changed filters while it loaded.
        if (request_id !== this.usersRequestId) {
          return;
        }
        this.setState({
          users: result.users,
          company: result.company,
          can_manage: result.can_manage,
          can_remove: result.can_remove,
          total_count: result.count,
          page_count: result.page_count,
          page_offset: result.page,
          active_user_count: result.active_user_count,
          active_admin_count: result.active_admin_count,
          loaded: true,
          loading_users: false,
          saving: false,
        });
      }
    );
  }

  openCreate() {
    this.setState({
      form_mode: 'create', form_user: { ...EMPTY_USER }, modal_error: '', success: '',
    });
  }

  openEdit(user) {
    this.setState({
      form_mode: 'edit',
      form_user: { ...user, active: user.active && user.is_active },
      modal_error: '',
      success: '',
    });
  }

  closeForm() {
    this.setState({ form_mode: null, modal_error: '', saving: false });
  }

  handleFormChange(event) {
    var form_user = { ...this.state.form_user };
    form_user[event.target.name] = event.target.type === 'checkbox'
      ? event.target.checked
      : event.target.value;
    this.setState({ form_user: form_user });
  }

  saveUser(event) {
    event.preventDefault();
    if (this.state.saving) {
      return;
    }

    var user = this.state.form_user;
    var is_create = this.state.form_mode === 'create';
    var existing_user = this.state.users.find((item) => item.id === user.id);

    // Existing users must go through the protected reassignment workflow
    // before they can be made inactive.
    if (!is_create && existing_user && existing_user.active && existing_user.is_active && !user.active) {
      if (!this.state.can_remove) {
        this.setState({
          modal_error: 'Only a DirectDocs administrator can deactivate or delete company users.',
          success: '',
        });
        return;
      }
      this.setState({ form_mode: null }, () => this.openDeactivation(user, 'deactivate'));
      return;
    }
    if (!is_create && existing_user && (!existing_user.active || !existing_user.is_active) && user.active) {
      this.setState({ form_mode: null }, () => this.openReactivation(user));
      return;
    }

    var url = `/users/company-users/${this.props.company_id}/`;
    if (!is_create) {
      url += `${user.id}/`;
    }

    this.setState({ saving: true, modal_error: '', success: '' });
    this.apiRequest('POST', url, {
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      phone_number: user.phone_number,
      is_staff: user.is_staff,
      active: user.active,
    }, (result) => {
      if (is_create && result.user.active && result.user.is_active) {
        ajaxWrapper('POST', '/api/email/', {
          to_email: result.user.email,
          from_email: 'support@directdocs.com',
          subject: 'You are invited to Direct Docs',
          text: 'Direct Docs is a platform to make medical records requests. '
            + 'Please <a href="https://directdocs.com/passwordReset/'
            + result.user.id + '/">set up your password here.</a>',
        }, () => { });
      }
      this.setState({
        form_mode: null,
        modal_error: '',
        saving: false,
        success: is_create ? 'User created successfully.' : 'User updated successfully.',
      }, this.refresh);
    }, 'modal_error');
  }

  isLastActiveAdministrator(user) {
    if (!user || !user.is_staff || !user.active || !user.is_active) {
      return false;
    }
    return this.state.active_admin_count <= 1;
  }

  openDeactivation(user, action = 'deactivate') {
    if (!this.state.can_remove) {
      this.setState({
        error: 'Only a DirectDocs administrator can deactivate or delete company users.',
        success: '',
      });
      return;
    }
    if (this.props.user && user.id === this.props.user.id) {
      this.setState({
        error: 'You cannot deactivate or delete your own account. Ask another administrator to do this.',
        success: '',
      });
      return;
    }
    this.setState({ error: '', success: '', saving: true });
    this.apiRequest(
      'GET',
      `/users/company-users/${this.props.company_id}/${user.id}/deactivation/`,
      {},
      (result) => this.setState({
        deactivation: result,
        deactivation_action: action,
        deactivation_is_staff: Boolean(user.is_staff),
        modal_error: '',
        replacement_user_id: '',
        saving: false,
      })
    );
  }

  openReassign(user) {
    if (!this.state.can_remove) {
      this.setState({
        error: 'Only a DirectDocs administrator or an administrator of this law firm can reassign requests.',
        success: '',
      });
      return;
    }
    this.setState({ error: '', success: '', saving: true });
    this.apiRequest(
      'GET',
      `/users/company-users/${this.props.company_id}/${user.id}/deactivation/?action=reassign`,
      {},
      (result) => this.setState({
        deactivation: result,
        deactivation_action: 'reassign',
        deactivation_is_staff: Boolean(user.is_staff),
        modal_error: '',
        replacement_user_id: '',
        saving: false,
      })
    );
  }

  deleteFromForm() {
    var user = this.state.form_user;
    this.setState({ form_mode: null }, () => this.openDeactivation(user, 'delete'));
  }

  closeDeactivation() {
    this.setState({
      deactivation: null,
      deactivation_action: 'deactivate',
      deactivation_is_staff: null,
      modal_error: '',
      replacement_user_id: '',
      saving: false,
    });
  }

  confirmDeactivation() {
    var deactivation = this.state.deactivation;
    var action = this.state.deactivation_action;
    var is_reassign = action === 'reassign';
    var replacement_required = is_reassign || deactivation.assigned_request_count > 0;
    if (this.state.saving || (replacement_required && !this.state.replacement_user_id)) {
      return;
    }

    this.setState({ saving: true, modal_error: '' });
    this.apiRequest(
      'POST',
      `/users/company-users/${this.props.company_id}/${deactivation.user.id}/deactivation/`,
      {
        replacement_user_id: this.state.replacement_user_id,
        action: action,
        is_staff: this.state.deactivation_is_staff,
      },
      (result) => this.setState({
        deactivation: null,
        deactivation_is_staff: null,
        modal_error: '',
        replacement_user_id: '',
        saving: false,
        success: is_reassign
          ? (result.replacement_user
            ? `${result.reassigned_request_count} request(s) reassigned to ${result.replacement_user.full_name}.`
            : 'Requests reassigned successfully.')
          : (result.replacement_user
            ? `${result.reassigned_request_count} request(s) reassigned to ${result.replacement_user.full_name}. `
            + `User ${action === 'delete' ? 'deleted' : 'deactivated'} successfully.`
            : `User ${action === 'delete' ? 'deleted' : 'deactivated'} successfully. No requests required reassignment.`),
      }, this.refresh),
      'modal_error'
    );
  }

  openReactivation(user) {
    this.setState({ reactivation: user, modal_error: '', success: '' });
  }

  closeReactivation() {
    this.setState({ reactivation: null, modal_error: '', saving: false });
  }

  confirmReactivation() {
    if (this.state.saving) {
      return;
    }
    var user = this.state.reactivation;
    this.setState({ saving: true, modal_error: '', success: '' });
    this.apiRequest(
      'POST',
      `/users/company-users/${this.props.company_id}/${user.id}/`,
      {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone_number: user.phone_number,
        is_staff: user.is_staff,
        active: true,
        confirm_reactivation: true,
      },
      () => this.setState({
        reactivation: null, modal_error: '', saving: false, success: 'User reactivated successfully.',
      }, this.refresh),
      'modal_error'
    );
  }

  handleSort(sort_key) {
    this.setState((state) => ({
      sort_key: sort_key,
      sort_direction: state.sort_key === sort_key && state.sort_direction === 'ascending'
        ? 'descending'
        : 'ascending',
      page_offset: 1,
    }), this.refresh);
  }

  handlePageClick(event) {
    this.setState({ page_offset: event.selected + 1 }, this.refresh);
  }

  handleLimitChange(event) {
    this.setState({ limit: parseInt(event.target.value, 10), page_offset: 1 }, this.refresh);
  }

  handleSearchChange(event) {
    var search_query = event.target.value;
    this.setState({ search_query: search_query, page_offset: 1 });
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(this.refresh, 300);
  }

  handleStatusChange(event) {
    this.setState({ status_filter: event.target.value, page_offset: 1 }, this.refresh);
  }

  renderSortableHeader(label, sort_key) {
    var is_active = this.state.sort_key === sort_key;
    var direction = this.state.sort_direction === 'ascending' ? 'Ascending' : 'Descending';
    return (
      <th style={{ cursor: 'pointer' }} aria-sort={is_active ? this.state.sort_direction : 'none'}>
        <a
          role="button"
          tabIndex="0"
          style={{ color: 'inherit', textDecoration: 'none' }}
          onClick={() => this.handleSort(sort_key)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              this.handleSort(sort_key);
            }
          }}
        >
          {label} {is_active && <span>({direction})</span>}
        </a>
      </th>
    );
  }

  renderUserForm() {
    var user = this.state.form_user;
    var is_current_user = this.props.user && user.id === this.props.user.id;
    // Last-administrator protection applies only to an existing user. A new
    // administrator must remain selectable even when the company has one admin.
    var is_last_active_admin = this.state.form_mode === 'edit'
      && this.isLastActiveAdministrator(user);
    var is_edit = this.state.form_mode === 'edit';
    var title = this.state.form_mode === 'create' ? 'Add Company User' : 'Edit Company User';
    var form = (
      <form onSubmit={this.saveUser}>
        {this.state.modal_error && <Alert type="danger" text={this.state.modal_error} />}
        <div className="form-row">
          <div className="form-group col-md-6">
            <label>First Name</label>
            <input className="form-control" name="first_name" value={user.first_name} onChange={this.handleFormChange} required />
          </div>
          <div className="form-group col-md-6">
            <label>Last Name</label>
            <input className="form-control" name="last_name" value={user.last_name} onChange={this.handleFormChange} required />
          </div>
        </div>
        <div className="form-group">
          <label>Email</label>
          <input className="form-control" type="email" name="email" value={user.email} onChange={this.handleFormChange} required />
          <small className="form-text text-muted">Email changes preserve this user's existing ID and request history.</small>
        </div>
        <div className="form-group">
          <label>Phone Number</label>
          <input className="form-control" name="phone_number" value={user.phone_number || ''} onChange={this.handleFormChange} />
        </div>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="company-user-admin" name="is_staff" checked={user.is_staff} onChange={this.handleFormChange} disabled={is_last_active_admin} />
          <label className="form-check-label" htmlFor="company-user-admin">Law Firm Administrator</label>
          {is_last_active_admin && (
            <small className="form-text text-muted">
              Add or promote another administrator before removing this administrator's access.
            </small>
          )}
        </div>
        <div className="form-check mt-2">
          <input
            className="form-check-input"
            type="checkbox"
            id="company-user-active"
            name="active"
            checked={Boolean(user.active)}
            onChange={this.handleFormChange}
            disabled={is_edit && ((user.active && !this.state.can_remove) || is_current_user)}
          />
          <label className="form-check-label" htmlFor="company-user-active">Active</label>
          {this.state.form_mode === 'edit' && user.active && (
            <small className="form-text text-muted">
              {!this.state.can_remove
                ? 'Only a DirectDocs administrator or a law-firm administrator can deactivate or delete company users.'
                : is_current_user
                  ? 'You cannot deactivate your own account.'
                  : 'Clearing Active will require confirmation and a replacement Main Contact when requests are assigned.'}
            </small>
          )}
        </div>
      </form>
    );
    var buttons = (
      <div>
        {this.state.form_mode === 'edit' && user.active && user.is_active && !is_current_user && this.state.can_remove && (
          <button className="btn btn-danger mr-2" type="button" disabled={this.state.saving} onClick={this.deleteFromForm}>
            Delete User
          </button>
        )}
        <button className="btn btn-light mr-2" type="button" onClick={this.closeForm}>Cancel</button>
        <button className="btn btn-primary" type="button" disabled={this.state.saving} onClick={this.saveUser}>
          {this.state.saving ? 'Saving...' : 'Save User'}
        </button>
      </div>
    );
    return <Modal show={true} title={title} content={form} buttons={buttons} onHide={this.closeForm} />;
  }

  renderDeactivationModal() {
    var details = this.state.deactivation;
    var action = this.state.deactivation_action;
    var is_delete = action === 'delete';
    var is_reassign = action === 'reassign';
    var replacement_required = is_reassign || details.assigned_request_count > 0;
    var replacement_options = details.replacement_users.map((user) => (
      <option key={user.id} value={user.id}>{user.full_name} ({user.email})</option>
    ));
    var content = (
      <div>
        {this.state.modal_error && <Alert type="danger" text={this.state.modal_error} />}
        <p>
          <strong>{details.user.full_name}</strong> is the Main Contact for{' '}
          <strong>{details.assigned_request_count}</strong> request(s).
        </p>
        {is_reassign ? (
          details.assigned_request_count > 0 ? (
            <p>
              Select an active company user to take over as the Main Contact for all active requests currently assigned to <strong>{details.user.full_name}</strong>.
            </p>
          ) : (
            <Alert type="info" text="This user currently has no active requests to reassign." />
          )
        ) : replacement_required ? (
          <p>
            Every linked request will be assigned to the replacement before this user is{' '}
            {is_delete ? 'deleted' : 'deactivated'}.
          </p>
        ) : (
          <p>No replacement is required because this user has no assigned requests.</p>
        )}
        {!is_reassign && (
          <Alert
            type="warning"
            text={`Please confirm that you want to ${is_delete ? 'delete' : 'deactivate'} this user. The user will no longer be able to sign in.`}
          />
        )}
        {replacement_required && details.assigned_request_count > 0 && <div className="form-group">
          <label>Replacement Main Contact</label>
          <select
            className="form-control"
            value={this.state.replacement_user_id}
            onChange={(event) => this.setState({ replacement_user_id: event.target.value })}
            required
          >
            <option value="">Select an active user</option>
            {replacement_options}
          </select>
        </div>}
        {replacement_required && details.assigned_request_count > 0 && details.replacement_users.length === 0 && (
          <Alert type="danger" text="Add or reactivate another company user before reassigning requests." />
        )}
      </div>
    );
    var buttons = (
      <div>
        <button className="btn btn-light mr-2" type="button" onClick={this.closeDeactivation}>Cancel</button>
        <button
          className={`btn ${is_reassign ? 'btn-info' : 'btn-danger'}`}
          type="button"
          disabled={this.state.saving || (replacement_required && (details.assigned_request_count === 0 || !this.state.replacement_user_id || details.replacement_users.length === 0))}
          onClick={this.confirmDeactivation}
        >
          {this.state.saving
            ? (replacement_required ? 'Reassigning...' : 'Saving...')
            : is_reassign
              ? 'Confirm and Reassign'
              : replacement_required
                ? `Confirm, Reassign and ${is_delete ? 'Delete' : 'Deactivate'}`
                : `Confirm and ${is_delete ? 'Delete' : 'Deactivate'}`}
        </button>
      </div>
    );
    return <Modal
      show={true}
      title={is_reassign ? 'Reassign Company User Requests' : `${is_delete ? 'Delete' : 'Deactivate'} Company User`}
      content={content}
      buttons={buttons}
      onHide={this.closeDeactivation}
    />;
  }

  renderReactivationModal() {
    var user = this.state.reactivation;
    var content = (
      <div>
        {this.state.modal_error && <Alert type="danger" text={this.state.modal_error} />}
        <Alert type="warning" text="Please confirm that you want to reactivate this company user." />
        <p>
          <strong>{user.full_name || `${user.first_name} ${user.last_name}`}</strong> will regain access
          using <strong>{user.email}</strong>.
        </p>
      </div>
    );
    var buttons = (
      <div>
        <button className="btn btn-light mr-2" type="button" onClick={this.closeReactivation}>Cancel</button>
        <button className="btn btn-success" type="button" disabled={this.state.saving} onClick={this.confirmReactivation}>
          {this.state.saving ? 'Reactivating...' : 'Confirm Reactivation'}
        </button>
      </div>
    );
    return <Modal show={true} title="Reactivate Company User" content={content} buttons={buttons} onHide={this.closeReactivation} />;
  }

  render() {
    var rows = this.state.users.map((user) => {
      var active = user.active && user.is_active;
      var is_current_user = this.props.user && user.id === this.props.user.id;
      var has_active_alternative = this.state.active_user_count > (active ? 1 : 0);
      var removal_disabled_reason = is_current_user
        ? 'You cannot remove your own account.'
        : user.assigned_request_count > 0 && !has_active_alternative
          ? 'Add or reactivate another company user to reassign this user\'s requests.'
          : '';
      var removal_disabled = Boolean(removal_disabled_reason);
      var reassign_disabled_reason = !user.assigned_request_count
        ? 'This user has no assigned requests to reassign.'
        : !has_active_alternative
          ? 'Add or reactivate another company user to reassign this user\'s requests.'
          : '';
      var reassign_disabled = Boolean(reassign_disabled_reason);
      return (
        <tr key={user.id}>
          <td>{user.full_name || `${user.first_name} ${user.last_name}`}</td>
          <td>{user.email}</td>
          <td>{user.phone_number || '-'}</td>
          <td>{user.is_staff ? 'Administrator' : 'User'}</td>
          <td>{user.assigned_request_count || 0}</td>
          <td><span className={`badge badge-${active ? 'success' : 'secondary'}`}>{active ? 'Active' : 'Inactive'}</span></td>
          {this.state.can_manage && (
            <td className="text-nowrap">
              <button
                className="btn btn-sm btn-primary mr-2"
                type="button"
                onClick={() => this.openEdit(user)}
              >
                Edit
              </button>

              {this.state.can_remove && (
                <button
                  className="btn btn-sm btn-info mr-2"
                  type="button"
                  disabled={reassign_disabled}
                  title={reassign_disabled_reason}
                  onClick={() => this.openReassign(user)}
                >
                  Reassign Requests
                </button>
              )}

              {active ? (
                this.state.can_remove && (
                  <button
                    className="btn btn-sm btn-warning mr-2"
                    type="button"
                    disabled={removal_disabled}
                    title={removal_disabled_reason}
                    onClick={() => this.openDeactivation(user, 'deactivate')}
                  >
                    Deactivate
                  </button>
                )
              ) : (
                <button
                  className="btn btn-sm btn-success mr-2"
                  type="button"
                  onClick={() => this.openReactivation(user)}
                >
                  Reactivate
                </button>
              )}

              {this.state.can_remove && (
                <button
                  className="btn btn-sm btn-danger"
                  type="button"
                  disabled={removal_disabled}
                  title={removal_disabled_reason}
                  onClick={() => this.openDeactivation(user, 'delete')}
                >
                  Delete
                </button>
              )}
            </td>
          )}
        </tr>
      );
    });

    var content = (
      <div className="container-fluid" style={{ position: 'relative' }}>
        <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
          <div>
            <h2 className="mb-1">Company Users</h2>
            <p className="text-muted mb-0">{this.state.company.name}</p>
          </div>
          {this.state.can_manage && <button className="btn btn-success" type="button" onClick={this.openCreate}>Add User</button>}
        </div>

        {!this.state.can_manage && <Alert type="info" text="You have read-only access to this company user list." />}
        {this.state.error && (
          <Alert type="danger" text={this.state.error} />
        )}
        {this.state.success && <Alert type="success" text={this.state.success} />}

        <div className="form-row mb-3">
          <div className="form-group col-md-8 mb-0">
            <label htmlFor="company-user-search">Search Users</label>
            <input
              id="company-user-search"
              className="form-control"
              type="search"
              placeholder="Search by name, email, or phone"
              value={this.state.search_query}
              onChange={this.handleSearchChange}
            />
          </div>
          <div className="form-group col-md-4 mb-0">
            <label htmlFor="company-user-status-filter">Status</label>
            <select
              id="company-user-status-filter"
              className="form-control"
              value={this.state.status_filter}
              onChange={this.handleStatusChange}
            >
              <option value="all">All Users</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                {this.renderSortableHeader('Name', 'name')}
                {this.renderSortableHeader('Email', 'email')}
                {this.renderSortableHeader('Phone', 'phone_number')}
                {this.renderSortableHeader('Role', 'role')}
                {this.renderSortableHeader('# of Requests as Main Contact', 'assigned_request_count')}
                <th>Status</th>
                {this.state.can_manage && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {!this.state.loading_users && rows}
              {this.state.loading_users && (
                <tr>
                  <td colSpan={this.state.can_manage ? 7 : 6} className="text-center text-muted py-4">
                    Loading users...
                  </td>
                </tr>
              )}
              {!this.state.loading_users && rows.length === 0 && (
                <tr>
                  <td colSpan={this.state.can_manage ? 7 : 6} className="text-center text-muted py-4">
                    No users match the selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {this.state.total_count > 0 && (
          <div className="d-flex justify-content-end align-items-center mb-3">
            <div>Total Records : {this.state.total_count}</div>
            <select
              className="form-control ml-3 mr-1"
              style={{ width: '85px' }}
              value={this.state.limit}
              onChange={this.handleLimitChange}
              aria-label="Users per page"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <ReactPaginate
              breakLabel="..."
              nextLabel="Next"
              onPageChange={this.handlePageClick}
              pageRangeDisplayed={5}
              marginPagesDisplayed={2}
              pageCount={this.state.page_count}
              previousLabel="Previous"
              renderOnZeroPageCount={null}
              className="custom-pagination"
              forcePage={this.state.page_offset - 1}
            />
          </div>
        )}

        {this.state.form_mode && this.renderUserForm()}
        {this.state.deactivation && this.renderDeactivationModal()}
        {this.state.reactivation && this.renderReactivationModal()}
      </div>
    );

    return <Wrapper loaded={this.state.loaded} content={content} />;
  }
}

export default InviteUsers;
